import {
  type CreateFxRateConfigDto,
  type UpdateFxRateConfigDto,
  createFxRateConfigService,
  deleteFxRateConfigService,
  getFxRateConfigsService,
  updateFxRateConfigService,
} from "@/services/fx-rate-configs.service";
import {useMutation, useQuery, useQueryClient} from "@tanstack/react-query";

const FX_RATE_CONFIGS_KEY = ["fx-rate-configs"] as const;

export const useFxRateConfigs = () =>
  useQuery({
    queryKey: [...FX_RATE_CONFIGS_KEY],
    queryFn: async () => {
      const {data} = await getFxRateConfigsService();
      if (data === undefined) throw new Error("No data");
      return data;
    },
  });

export const useCreateFxRateConfig = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (body: CreateFxRateConfigDto) => createFxRateConfigService(body),
    onSuccess: () => {
      queryClient.invalidateQueries({queryKey: FX_RATE_CONFIGS_KEY});
    },
  });
};

export const useUpdateFxRateConfig = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({id, body}: {id: string; body: UpdateFxRateConfigDto}) => updateFxRateConfigService(id, body),
    onSuccess: () => {
      queryClient.invalidateQueries({queryKey: FX_RATE_CONFIGS_KEY});
    },
  });
};

export const useDeleteFxRateConfig = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => deleteFxRateConfigService(id),
    onSuccess: () => {
      queryClient.invalidateQueries({queryKey: FX_RATE_CONFIGS_KEY});
    },
  });
};
